import { handleActions } from 'redux-actions';
import { GET_INTERVIEWS_START, GET_INTERVIEWS_SUCCESS, GET_INTERVIEWS_ERROR, GET_TIMESLOTS_SUCCESS } from '../actions/actionTypes';

const initialState = {
  interviewSlots: {},
  interviewsList: [],
  isLoading: false,
  error: null
};

export default handleActions(
  {
    [GET_INTERVIEWS_START]: state => ({
      ...state,
      isLoading: true,
      error: null
    }),
    [GET_INTERVIEWS_SUCCESS]: (state, action) => ({
      ...state,
      interviewsList: action.interviewsList,
      isLoading: false,
      error: null
    }),
    [GET_TIMESLOTS_SUCCESS]: (state, action) => ({
      ...state,
      interviewSlots: action.data,
      isLoading: false,
      error: null
    }),
    [GET_INTERVIEWS_ERROR]: (state, action) => ({
      ...state,
      isLoading: false,
      error: action.error
    })
  },
  initialState
);



// WEBPACK FOOTER //
// ./src/reducers/orientationDates.js